<template>
  <div class="kyc-container">
    <!-- Top Status -->
    <div class="top-bar">
      <div class="status-left">
        <span class="text-[#383F51] font-normal text-[16px]">Verification Status:</span>
        <span class="badge">---</span>
      </div>

      <div class="info text-[#14171F] font-normal text-[16px]">
        Document validation commences once document upload is complete
      </div>
    </div>

    <!-- Summary Cards -->
    <div class="pre-summary" v-if="hasData">
      <div class="summary">
        <div class="po-summary">
         
          <div class="cards ">
            <div class="icon blue">
              <img src="@/assets/images/ondemand/KYC/docUploadIcon.svg" alt="" srcset="">
            </div>
            <div>
              <p class="text-[#667499] text-[12px] font-normal">Document Upload</p>
              <strong>{{documentUpload || "--"}}</strong>           
            </div>
          </div>

          <div class="cards">
            <div class="icon green">
              <img src="@/assets/images/ondemand/KYC/validatedIcon.svg" alt="" srcset="">
            </div>
            <div>
              <p class="text-[#667499] text-[12px] font-normal">Validated</p>
              <strong>{{docStats.validated || "--"}}</strong>
            </div>
          </div>

          <div class="cards">
            <div class="icon yellow">
              <img src="@/assets/images/ondemand/KYC/pendingIcon.svg" alt="" srcset="">
            </div>
            <div>
              <p class="text-[#667499] text-[12px] font-normal">Pending</p>
              <strong>{{docStats.pending || "--"}}</strong>
            </div>
          </div>

          <div class="cards">
            <div class="icon red">
              <img src="@/assets/images/ondemand/KYC/failedIcon.svg" alt="" srcset="">
            </div>
            <div>
              <p class="text-[#667499] text-[12px] font-normal">Failed</p>
              <strong>{{docStats.failed || "--"}}</strong>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Documents Section -->
    <div class="documents " v-if="hasData">
      <div class="header" @click="toggleBODOC">
        <h3 class="text-[#14171F] text-[18px] font-bold">Organization Documents</h3>

        <!-- Rotating Arrow -->
        <span class="arrow" :class="{ open: isBODOCOpen }">
          ˅
        </span>
      </div>

      <div v-if="isBODOCOpen" class="table">
        <div class="table-head">
          <span class="text-[#383F51] text-[16px] font-normal">Document Name</span>
          <span class="text-[#383F51] text-[16px] font-normal">Upload Status</span>
          <span class="text-[#383F51] text-[16px] font-normal">Validation Status</span>
        </div>

        <div v-for="(doc, index) in documents.filter(d => d.documentName !== 'Tax ID')" :key="index" class="table-row">
          <span class="text-[#10233E] text-[16px] font-normal">{{ doc.documentName.replace(/\(.*?\)/g, '').trim() }}</span>
          <span class="text-[#14171F] text-[16px] font-normal flex items-center gap-4">{{ doc.uploadStatus === "not_uploaded" ?  '---' : doc.uploadStatus }} <span><img v-if="doc.uploadStatus === 'uploaded'" src="@/assets/images/ondemand/KYC/checked.svg" alt="" srcset=""></span> <span class="cursor-pointer" @click='reUpload("Incorporated")'><img   src="@/assets/images/ondemand/KYC/reUpload.svg" alt="" srcset=""></span></span>
          <span class="text-[#14171F] text-[16px] font-normal flex items-center gap-4">{{ doc.validationStatus || '---' }} <span><img v-if="doc.validationStatus === 'pending'" src="@/assets/images/ondemand/KYC/pendingValidationStatusIcon.svg" alt="" srcset=""></span></span>
        </div>
      </div>
    </div>

    <!-- Documents Section -->
    <div class="documents boDoc" v-if="hasData">
      <div class="header" @click="toggle">
        <h3 class="text-[#14171F] text-[18px] font-bold">Beneficial Owners Documents</h3>

        <!-- Rotating Arrow -->
        <span class="arrow" :class="{ open: isOpen }">
          ˅
        </span>
      </div>

      <div v-if="isOpen" class="table">
        <div class="table-head">
          <span class="text-[#383F51] text-[16px] font-normal">Document Name</span>
          <span class="text-[#383F51] text-[16px] font-normal">Upload Status</span>
          <span class="text-[#383F51] text-[16px] font-normal">Validation Status</span>
        </div>

        <div  v-for="(doc, index) in proof" :key="index">
          <div class="proof-header" @click="togglePOD">
            <h3 class="text-[#14171F] text-[18px] font-bold">{{doc.ownerName}}</h3>

            <!-- Rotating Arrow -->
            <span class="arrow" :class="{ open: isPODOpen }">
              ˅
            </span>
          </div>

          <div v-if="isPODOpen">
            <div class="table-row" v-for="(bod, index) in Object.values(doc.documents)" :key="index">
              <span class="text-[#10233E] text-[16px] font-normal">{{ bod.documentName }}</span>
              <span class="text-[#14171F] text-[16px] font-normal flex items-center gap-4">{{ bod.uploadStatus === "not_uploaded" ?  '---' : bod.uploadStatus }} <span><img v-if="bod.uploadStatus === 'uploaded'" src="@/assets/images/ondemand/KYC/checked.svg" alt="" srcset=""></span> <span  class="cursor-pointer" @click='reFresh("Owner")'><img  src="@/assets/images/ondemand/KYC/reUpload.svg" alt="" srcset=""></span></span>
              <span class="text-[#14171F] text-[16px] font-normal flex items-center gap-4"> {{ bod.validationStatus || '---' }} <span><img v-if="bod.validationStatus === 'pending'" src="@/assets/images/ondemand/KYC/pendingValidationStatusIcon.svg" alt="" srcset=""></span></span>
            </div>
          </div>
        </div>
       
      </div>
    </div>

    <div v-if="!hasData">
      <h3 class="text-[#14171F] text-[18px] font-bold text-center mt-4 mb-6">No KYC Documents Yet</h3>
      <div class="empty-para">
        <p class="text-center">It looks like you have not added any KYC details for your organization, beneficial owners, or dependent riders. <br />
          When KYC submissions begin, you will find all related documents summarized here.<br /><br />Start by updating your organization details, adding beneficial owners, or inviting riders to submit their KYC.</P>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  data() {
    return {
      beneficialOwnerDocuments: [],
      organizationDocuments: {},
     documentUpload: "",
     pending: "",
     failed: "",
     validated: "",
      docStats: {},
      docData: {},
      isOpen: false,
      isPODOpen: true,
      isBODOCOpen: true,
      documents: [
        { name: "Certificate of Incorporation" },
        { name: "CAC 1.1" },
        { name: "MERMAT" },
        { name: "Status Report" },
        { name: "Regulatory License" },
        { name: "Tax ID" },
        { name: "Proof of Address (Organisation)" }
      ],
       proof: [
        { name: "Proof of Address" },
        { name: "Proof of Identity" },
      ]
    };
  },
   mounted() {
          this.findBusinessDocs();  
    },

    computed: {
  hasData() {
    const data = this.docData

    if (!data) return false

    // check if any document group has data
    return (
      Object.keys(data.organizationDocuments || {}).length > 0 ||
      Object.keys(data.individualDocuments || {}).length > 0 ||
      (data.beneficialOwnerDocuments || []).length > 0
    )
  }
},

  methods: {
      reUpload(val) {
      this.$emit('goToBusiness', val);
    },
    reFresh(val) {
      this.$emit('goToBeneficialOwner', val);
    },
    async findBusinessDocs() {
      try {
        let response = await this.$_getBizzDocs();
        this.documents = Object.values(response.data.data.organizationDocuments);
        this.docData = response?.data?.data;
        this.docStats = this.docData.stats;
        this.documentUpload = this.docStats.documentUpload;
        this.pending = this.docStats.pending;
        this.failed = this.docStats.failed;
        this.validated = this.docStats.validated;
        this.organizationDocuments = this.docData.organizationDocuments;
        this.proof = this.docData.beneficialOwnerDocuments;
      
      } catch (error) {
        console.error("Error fetching business documents:", error);
        // this.handleError(error);
      }
    },
    toggle() {
      this.isOpen = !this.isOpen;
    },
    toggleBODOC() {
      this.isBODOCOpen = !this.isBODOCOpen;
    },
    togglePOD(){
      this.isPODOpen = !this.isPODOpen;
    }
  }
};
</script>

<style scoped>
.kyc-container {
  font-family: Arial, sans-serif;
  padding: 20px;
}

/* Top Bar */
.top-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
}

.badge {
  background: #F0F4FE;
  padding: 10px 10px;
  border-radius: 5px;
  margin-left: 8px;
}

.info {
  background: #fff4e5;
  padding: 8px 12px;
  border-radius: 12px;
  border: 0.5px solid #F7B538;
}

/* Summary */
.pre-summary {
  margin-bottom: 20px;
  border-radius: 5px;
  padding: 15px;
  box-shadow:
    0px 2px 24px -2px rgba(30, 30, 30, 0.04),
    0px 4px 24px -2px rgba(30, 30, 30, 0.06);
}

.summary {
  border-radius: 5px;
     padding: 8px;
     border: 1px dashed #7A90A7;
}
.po-summary {
  background-color: #F2F7FC;
  display: flex;
  flex-wrap: wrap;
  padding-top: 10px;
  padding-bottom: 10px;
  border-radius: 8px;
}
.po-summary>:nth-child(1),.po-summary>:nth-child(2),.po-summary>:nth-child(3) {
  border-right: 1px dashed #4142455C;
}
.cards {
  padding-left: 3%;
  background-color: #F2F7FC;
  display: flex;
  gap: 10px;
  align-items: center;
  flex: 1;
  border: none;
}

.icon {
  width: 40px;
  height: 40px;
  border-radius: 10px;
}

.blue {
  background: #dbeafe;
}

.green {
  background: #d1fae5;
}
.yellow {
  background: #fef3c7;
}
.red {
  background: #fee2e2;
}


/* Documents */
.documents {
  border: 1px solid #383F51;
  border-radius: 8px;
}
.header {
  display: flex;
  justify-content: space-between;
  padding: 15px;
  cursor: pointer;
  font-weight: bold;
}
.proof-header {
  display: flex;
  justify-content: space-between;
  padding-top: 15px;
  padding-bottom: 15px;
  cursor: pointer;
  font-weight: bold;
}

/* Arrow rotation */
.arrow {
  display: inline-block;
  transition: transform 0.3s ease;
}

.arrow.open {
  transform: rotate(180deg);
}

/* Table */
.table {
  padding: 10px 15px;
}

.table-head,
.table-row {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  padding: 10px 0;
}

.table-head {
  font-weight: bold;
  border-bottom: 1px solid #ddd;
}

.table-row {
  border-bottom: 1px solid #f0f0f0;
}
.boDoc {
  margin-top: 20px;
}
.empty-para {
  width: 85%;
  margin: 0 auto;
}
</style>